import { Trophy, ShoppingCart, Wrench } from 'lucide-react';

import { cn } from '@/utils';

import { CART_ITEM_TYPE } from '../../enums';

import { Card, CardContent } from '@/components/ui/card';

const SelectItemType = ({ itemType, setItemType }) => {
  const handleSelectItemType = (itemType) => {
    if (itemType === CART_ITEM_TYPE.OFFERING) {
      setItemType(itemType);
    }
  };

  return (
    <div className="grid grid-cols-3 gap-4 mb-2">
      <Card
        className={cn(
          itemType === CART_ITEM_TYPE.OFFERING &&
            'border-2 border-secondary scale-105 transition-transform duration-300 ease-in-out transform'
        )}
        onClick={() => handleSelectItemType(CART_ITEM_TYPE.OFFERING)}
      >
        <CardContent className="p-4 text-center flex flex-col justify-center items-center gap-1">
          <h3 className="text-lg font-bold">Offering</h3>
          <Trophy />
        </CardContent>
      </Card>

      <Card
        className={cn(
          'opacity-50',
          itemType === CART_ITEM_TYPE.PRODUCT &&
            'border-2 border-secondary scale-105 transition-transform duration-300 ease-in-out transform'
        )}
        onClick={() => handleSelectItemType(CART_ITEM_TYPE.PRODUCT)}
      >
        <CardContent className="p-4 text-center flex flex-col justify-center items-center gap-1">
          <h3 className="text-lg font-bold">Product</h3>
          <ShoppingCart />
          <span className="text-[9px] text-muted-foreground">Coming Soon!</span>
        </CardContent>
      </Card>
      <Card
        className={cn(
          'opacity-50',
          itemType === CART_ITEM_TYPE.SERVICE &&
            'border-2 border-secondary scale-105 transition-transform duration-300 ease-in-out transform'
        )}
        onClick={() => handleSelectItemType(CART_ITEM_TYPE.SERVICE)}
      >
        <CardContent className="p-4 text-center flex flex-col justify-center items-center gap-1">
          <h3 className="text-lg font-bold">Service</h3>
          <Wrench />
          <span className="text-[9px] text-muted-foreground">Coming Soon!</span>
        </CardContent>
      </Card>
    </div>
  );
};

export default SelectItemType;
